module.exports = __webpack_public_path__ + "img/runner-up.3f565e19.png";